import { Text } from '@doda/io-react/common';
import { FC } from 'react';
import style from './index.module.scss';

/**
 * Props
 * @param searchConditionLabel 検索条件ラベル
 */
interface Props {
  searchConditionLabel: string | undefined;
}

export const LabelText: FC<Props> = ({ searchConditionLabel }) => {
  return (
    <div className={style['searchConditionLabel-text']}>
      <Text size="12" color="gray">
        {searchConditionLabel ?? '検索条件が選択されていません'}
      </Text>
    </div>
  );
};
